import React from "react";
import { Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorIcon from "@mui/icons-material/Error";

const ChatMessage = ({
  text,
  isOwn, // true si es enviado por nosotros (supervisor-cabin / agente)
  time, // fecha o timestamp (msg.dataSend)
  isImage, // si msg.class === "image"
  onImageClick,
  status, // "sent" | "delivered" | "read" | "failed" | "error" | etc.
}) => {
  const formattedTime = time
    ? new Date(time).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  const normalizedStatus = typeof status === "string" ? status.toLowerCase() : "";

  const renderStatus = () => {
    if (!isOwn) return null;

    if (normalizedStatus === "failed" || normalizedStatus === "error") {
      return (
        <div style={styles.errorContainer}>
          <ErrorIcon style={styles.errorIcon} />
          <span style={styles.errorText}>no se ha podido enviar</span>
        </div>
      );
    }

    if (normalizedStatus === "read" || normalizedStatus === "seen") {
      return <DoneAllIcon style={styles.checkIconRead} />;
    }

    if (normalizedStatus === "delivered") {
      return <DoneAllIcon style={styles.checkIconDelivered} />;
    }

    if (normalizedStatus === "sent" || normalizedStatus === "sending") {
      return <DoneIcon style={styles.checkIconSent} />;
    }

    return <DoneIcon style={styles.checkIconSent} />;
  };

  return (
    <div
      style={{
        ...styles.messageRow,
        justifyContent: isOwn ? "flex-end" : "flex-start",
      }}
    >
      <div
        style={{
          ...styles.bubble,
          ...(isOwn ? styles.bubbleOwn : styles.bubbleReply),
        }}
      >
        {isImage ? (
          <div
            style={styles.imageContainer}
            onClick={() => onImageClick && onImageClick(text)}
          >
            <img src={text} alt="Adjunto de chat" style={styles.image} />
          </div>
        ) : (
          <Typography style={styles.text}>{text}</Typography>
        )}

        <div style={styles.metaContainer}>
          <span
            style={{
              ...styles.time,
              color: "var(--chat-text-secondary, #667781)",
            }}
          >
            {formattedTime}
          </span>
          {renderStatus()}
        </div>
      </div>
    </div>
  );
};

const styles = {
  messageRow: {
    display: "flex",
    width: "100%",
    marginBottom: "4px",
    padding: "0 8px",
  },
  bubble: {
    position: "relative",
    minWidth: "70px",
    maxWidth: "65%",
    padding: "6px 8px 20px 10px", // Margen inferior extra para acomodar la hora
    borderRadius: "8px",
    boxShadow: "0 1px 0.5px rgba(11,20,26,.13)",
    wordBreak: "break-word",
    display: "flex",
    flexDirection: "column",
  },
  bubbleOwn: {
    backgroundColor: "var(--chat-bg-bubble-own, #d9fdd3)", // Verde clásico de WhatsApp para mensajes propios
    color: "var(--chat-text-bubble-own, #111b21)",
    borderTopRightRadius: "0px", // Efecto "cola" de la burbuja
    marginLeft: "auto",
  },
  bubbleReply: {
    backgroundColor: "var(--chat-bg-bubble-reply, #ffffff)", // Blanco para mensajes de otros
    color: "var(--chat-text-bubble-reply, #111b21)",
    borderTopLeftRadius: "0px",
    marginRight: "auto",
  },
  text: {
    fontSize: "14.2px",
    lineHeight: "1.4",
    fontFamily: "Raleway, sans-serif",
    whiteSpace: "pre-wrap",
  },
  imageContainer: {
    cursor: "pointer",
    overflow: "hidden",
    borderRadius: "6px",
    marginBottom: "4px",
    maxWidth: "240px",
    maxHeight: "240px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--chat-border, #eae6df)",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  metaContainer: {
    position: "absolute",
    bottom: "2px",
    right: "6px",
    display: "flex",
    alignItems: "center",
    gap: "3px",
  },
  time: {
    fontSize: "10px",
    fontFamily: "Raleway, sans-serif",
    userSelect: "none",
  },
  errorContainer: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
  },
  errorIcon: {
    fontSize: "13px",
    color: "#e53935",
  },
  errorText: {
    fontSize: "9px",
    color: "#e53935",
    fontFamily: "Raleway, sans-serif",
    userSelect: "none",
  },
  checkIconSent: {
    fontSize: "14px",
    color: "#8696a0",
  },
  checkIconDelivered: {
    fontSize: "14px",
    color: "#8696a0",
  },
  checkIconRead: {
    fontSize: "14px",
    color: "#53bdeb",
  },
};

export default ChatMessage;
